// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 618 ? "smoke" : chunkId) + "." + {"518":"b9f21678b523b68bcf01","618":"bc693856226b056b53d5"}[chunkId] + ".js";
};